import {defineStore} from 'pinia'

export const useIdefix3AdditionalFields = defineStore('idefix3AdditionalFields', {
    state: () => {
        return {
            ports: [],
            portsRules: [],
            version: '',
        }
    },
    actions: {

        /* Yes we have parseInt here but the one that does the trick is in the save.php where we are typecasting the string to the integer, we are having these parseInt here as well, as we want to always deal with integers for the consistency standpoint */
        getVersion() {

            if (typeof this.version === 'string') {
                return parseInt(this.version);
            }

            return this.version;

        },
        /* Yes we have parseInt here but the one that does the trick is in the save.php where we are typecasting the string to the integer, we are having these parseInt here as well, as we want to always deal with integers for the consistency standpoint */
        setVersion(version) {
            if (typeof version === 'string') {
                this.version = parseInt(version);
            } else {
                this.version = version;
            }
        },
        getPorts() {
            return this.ports;
        },
        setPorts(ports) {
            this.ports = ports;
        },
        getPortsRules() {
            return this.portsRules;
        },
        setPortsRules(portsRules) {
            this.portsRules = portsRules;
        }

    },
    getters: {}
})
